import { render, staticRenderFns } from "./shareRecord.vue?vue&type=template&id=dc2d0de4&scoped=true&"
import script from "./shareRecord.vue?vue&type=script&lang=js&"
export * from "./shareRecord.vue?vue&type=script&lang=js&"
import style0 from "./shareRecord.vue?vue&type=style&index=0&id=dc2d0de4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2d0de4",
  null
  
)

export default component.exports